import type { GetDocumentFileAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDocumentFileAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDocumentFileAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDocumentFileAuditByIdArgs = {
  id: string;
};

export const useGetDocumentFileAuditById = createQueryHook<
  UseGetDocumentFileAuditByIdArgs,
  GetDocumentFileAuditByIdResponseRow[],
  GetDocumentFileAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getDocumentFileAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ document_file_audit: data }),
  graphqlDocument: GetDocumentFileAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
